import React from 'react';
import { Link } from 'react-router-dom';
import './LoginPage.css'; // Reuse the same styling

const PrivacyPage = () => {
  return (
    <div className="login-page">
      <div className="login-container" style={{ maxWidth: '800px' }}>
        <div className="login-header">
          <img 
            src="/encore_logo_notext_min.png" 
            alt="Panorama" 
            className="login-logo"
          />
          <h1>Privacy Policy</h1>
        </div>

                <div className="login-content" style={{ textAlign: 'left' }}>
        <div style={{ padding: '20px' }}>
            <p><strong>Last Updated:</strong> 2025-10-20</p>

            <h2>1. Introduction</h2>
            <p>
            This Privacy Policy describes how <strong>Encore Interactive Inc.</strong> (“Encore Interactive”, “we”, “us”, or “our”) 
            collects, uses, and protects personal information in connection with the use of our invite-only application 
            (“the Service”). We are committed to protecting your privacy and complying with applicable privacy laws, 
            including the <strong>Personal Information Protection and Electronic Documents Act (PIPEDA)</strong> and the laws 
            of the Province of New Brunswick, Canada.
            </p>
            <p>
            By using our Service, you consent to the collection, use, and disclosure of your information as described in this Privacy Policy.
            </p>

            <h2>2. Information We Collect</h2>
            <p><strong>We collect only the personal information necessary to provide and improve the Service.</strong></p>

            <p><strong>User Information:</strong> We collect your email address when you are invited to join the Service. It is used for account creation, authentication, and communication related to the Service.</p>

            <p><strong>Usage Information:</strong> We automatically collect data on how you interact with the Service, such as pages accessed, features used, session duration, and performance metrics. This data helps us understand user behaviour, identify performance issues, and plan future improvements.</p>

            <p>We do not collect sensitive personal data such as payment details, contact lists, or precise location tracking.</p>

            <h2>3. How We Use Your Information</h2>
            <p>
            Encore Interactive uses your information to:
            <ul>
                <li>Operate, maintain, and improve the Service;</li>
                <li>Authenticate and manage user access;</li>
                <li>Analyze usage behaviour and identify performance issues;</li>
                <li>Plan service improvements and new features;</li>
                <li>Communicate updates or changes related to the Service.</li>
            </ul>
            </p>

            <h2>4. Legal Basis for Processing</h2>
            <p>
            We collect and process personal information based on:
            <ul>
                <li><strong>Consent:</strong> You provide consent when accepting an invitation and using the Service.</li>
                <li><strong>Legitimate Interests:</strong> We process data to ensure service functionality and improve reliability and user experience.</li>
            </ul>
            </p>

            <h2>5. Data Retention</h2>
            <p>
            Encore Interactive retains personal information only as long as necessary to fulfill the purposes outlined in this policy or as required by law. 
            When no longer needed, information is securely deleted or anonymized in accordance with our data retention policy.
            </p>

            <h2>6. Data Storage and International Transfers</h2>
            <p>
            Personal information and usage data are stored in <strong>data centres located in the United States</strong>. 
            While this means your data may be subject to U.S. laws, Encore Interactive ensures that:
            <ul>
                <li>All data is transmitted and stored securely;</li>
                <li>Third-party service providers maintain privacy protections equivalent to Canadian standards;</li>
                <li>Appropriate safeguards are in place in accordance with PIPEDA for cross-border data transfers.</li>
            </ul>
            </p>

            <h2>7. Data Security</h2>
            <p>
            We employ physical, technical, and organizational safeguards to protect your data, including:
            <ul>
                <li>Encryption of data in transit and at rest;</li>
                <li>Access controls and secure authentication;</li>
                <li>Regular monitoring and vulnerability management.</li>
            </ul>
            While we take all reasonable steps to secure data, no system is completely immune to risk.
            </p>

            <h2>8. Disclosure of Information</h2>
            <p>
            Encore Interactive does not sell, rent, or trade personal information. We may share information only:
            <ul>
                <li>With trusted third-party providers assisting in hosting, analytics, or system operation, under confidentiality obligations;</li>
                <li>When required by law, court order, or government request;</li>
                <li>To protect the rights, property, or safety of Encore Interactive, our users, or the public.</li>
            </ul>
            </p>

            <h2>9. Your Rights</h2>
            <p>
            You have the right to:
            <ul>
                <li>Access and request a copy of your personal information;</li>
                <li>Request correction of inaccurate or incomplete information;</li>
                <li>Withdraw consent (subject to legal or contractual restrictions);</li>
                <li>File a complaint with the <strong>Office of the Privacy Commissioner of Canada (OPC)</strong> or the <strong>Access to Information and Privacy Office of New Brunswick</strong>.</li>
            </ul>
            To exercise these rights, contact us as outlined below.
            </p>

            <h2>10. Changes to This Policy</h2>
            <p>
            Encore Interactive may update this Privacy Policy periodically to reflect changes in law, business practices, or technology. 
            Updated versions will include a new effective date and may be communicated via email or in-app notification.
            </p>

            <h2>11. Contact Information</h2>
            <p>
            For questions, concerns, or requests about this Privacy Policy, contact:
            </p>
            <p>
            <strong>Privacy Officer</strong><br />
            Encore Interactive Inc.<br />
            Please contact your account manager for contact details<br />
            </p>
        </div>
        </div>

        <div className="login-footer">
          <p>
            <Link to="/login" style={{ color: '#667eea', textDecoration: 'none' }}>
              ← Back to Login
            </Link>
            {' | '}
            <Link to="/terms" style={{ color: '#667eea', textDecoration: 'none' }}>
              Terms and Conditions
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
